
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 15.25 22.095\" id=\"icon-marker-view\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M7.763,0.002C7.712,0.002,7.674-0.001,7.624,0C7.582,0,7.529,0.003,7.486,0.003C3.351,0.003,0,3.399,0,7.49\r\n\tc0,6.142,7.627,14.605,7.627,14.605S15.25,13.25,15.25,7.489C15.25,3.411,11.898,0.002,7.763,0.002 M7.607,10.26\r\n\tc-1.894,0-3.43-1.535-3.43-3.43c0-1.894,1.536-3.43,3.43-3.43c1.895,0,3.431,1.536,3.431,3.43C11.038,8.725,9.502,10.26,7.607,10.26\r\n\t\"/> </symbol>";
module.exports = sprite.add(image, "icon-marker-view");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/marker-view.svg
 ** module id = 201
 ** module chunks = 24
 **/